import styles from './Svg.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Svg({
  accessibilityLabel,
  children,
  height,
  width,
  tabIndex = 0
}) {
  const hasLabel = accessibilityLabel != null;
  return /*#__PURE__*/jsxs("svg", {
    viewBox: `0 0 ${width} ${height}`,
    height: height,
    width: width,
    role: hasLabel ? 'img' : undefined,
    className: styles.SVG,
    tabIndex: tabIndex,
    children: [hasLabel && /*#__PURE__*/jsx("title", {
      children: accessibilityLabel
    }), children]
  });
}

export { Svg };
